import { HEALTH_ENROLLMENT_STATUSES } from 'platform/shared/health-apps';

const NO_VES_RECORD_STATUSES = new Set([
  null,
  HEALTH_ENROLLMENT_STATUSES.noneOfTheAbove,
]);

const REJECTED_OR_CLOSED_STATUSES = new Set([
  HEALTH_ENROLLMENT_STATUSES.rejectedIncWrongEntry,
  HEALTH_ENROLLMENT_STATUSES.rejectedRightEntry,
  HEALTH_ENROLLMENT_STATUSES.rejectedScWrongEntry,
  HEALTH_ENROLLMENT_STATUSES.canceledDeclined,
  HEALTH_ENROLLMENT_STATUSES.closed,
]);

export const APPLY_ELIGIBLE_STATUSES = new Set([
  ...NO_VES_RECORD_STATUSES,
  ...REJECTED_OR_CLOSED_STATUSES,
]);

/**
 * Select the shared `healthEnrollmentStatus` slice. The reference only changes
 * when the slice does, so it is safe to use with `useSelector` as-is.
 *
 * @param {Object} state - Redux state
 * @returns {Object} the `healthEnrollmentStatus` slice
 */
export const selectHealthEnrollmentStatus = state =>
  state.healthEnrollmentStatus;

/**
 * @param {Object} state - Redux state
 * @returns {string|null} the parsed enrollment status
 */
export const selectParsedStatus = state =>
  selectHealthEnrollmentStatus(state).parsedStatus;

/**
 * @param {Object} state - Redux state
 * @returns {boolean} true when the parsed status allows a new application
 */
export const selectHasApplyStatus = state =>
  APPLY_ELIGIBLE_STATUSES.has(selectParsedStatus(state));

/**
 * @param {Object} state - Redux state
 * @returns {boolean} true when a VES record exists for the user
 */
export const selectVesRecordFound = state =>
  !NO_VES_RECORD_STATUSES.has(selectParsedStatus(state));
